export type ProviderType = 'Enetpulse';

export type WidgetTypes =
  | 'HeadToHead'
  | 'TournamentStandings'
  | 'DrawStandings'
  | 'MatchIncidents'
  | 'MatchFormations'
  | 'WinProbability'
  | 'MatchStatistics';

export const widgetIds: Record<WidgetTypes, string> = {
  HeadToHead: 'FW44FCD196BD790202',
  TournamentStandings: 'FW36F0F2C9FA6969A8',
  DrawStandings: 'FWCBB6076A5B4BA480',
  MatchIncidents: 'FWC109FD7297551815',
  MatchFormations: 'FW9056E44E90FE18B2',
  WinProbability: 'FWA0A67B4AADF193FB',
  MatchStatistics: 'FW34658FC0561EA1A4',
};

export type EnetpulseContentObject = {
  provider: 'Enetpulse';
  type: WidgetTypes;
  viewProps?: {
    renderGeneralMatchInfo?: boolean;
    hasMultipleWidgets?: boolean;
    options?: Record<string, string | number>;
  };
};
